import { Avatar, Flex, List, Skeleton, Typography } from "antd";
import {
  ClockCircleFilled,
  CheckCircleFilled,
  CloseCircleFilled,
  FileFilled,
} from "@ant-design/icons";
import { APPLICATION_STATUS } from "enum/job-status-type";
import ErrorPage from "components/ui/ErrorPage";
import { useGetMyJobs } from "api/jobs/useGetMyJobs";
import { storage } from 'utils/storage';
import { Link } from "react-router-dom";
import { JobInterface } from "api/jobs/dto";

const { Text } = Typography;

const joblocationFormat = (item: JobInterface) => {
  const locations = item.joblocation || [];

  if (locations.length === 0) {
    return "Location not specified";
  } else if (locations.length > 2) {
    const displayedLocations = locations
      .slice(0, 2)
      .map(loc => `${loc.district} ${loc.province}`)
      .join(", ");
    const remaining = locations.length - 2;
    return `${displayedLocations} and ${remaining} more`;
  } else {
    return locations.map(loc => `${loc.district} ${loc.province}`).join(", ");
  }
};


const AppliedJobs = () => {
  const user = storage.getUserFromStorage();

  const { data, isFetching, error } = useGetMyJobs({
    isApplied: true,
    isSaved: false,
    userId: user?.uid
  });


  const getJobStatus = (status: APPLICATION_STATUS) => {
    switch (status) {
      case APPLICATION_STATUS.SUBMITTED:
        return (
          <>
            <Flex gap={"middle"} align="start">
              <FileFilled style={{ marginTop: "6px", fontSize: "20px", color: "#3b7ded" }} />

              <Flex vertical>
                <Text strong className="text-base text-sent">
                  Application Sent
                </Text>
              </Flex>
            </Flex>
          </>
        );

      case APPLICATION_STATUS.SHORT_LISTED:
        return (
          <>
            <Flex gap={"middle"} align="start">
              <ClockCircleFilled style={{ marginTop: "2px", fontSize: "20px", color: "#FBBF24" }} />
              <Flex vertical>
                <Text strong className="text-base text-pending">

                  Reviewed and Shortlisted
                </Text>
              </Flex>
            </Flex>
          </>
        );

      case APPLICATION_STATUS.APPROVED:
        return (
          <>
            <Flex gap={"middle"} align="start">
              <CheckCircleFilled style={{ marginTop: "2px", fontSize: "20px", color: "#16a34a" }} />
              <Flex vertical>
                <Text strong className="text-base  text-accepted">

                  Application Approved

                </Text>
              </Flex>
            </Flex>
          </>
        );

      case APPLICATION_STATUS.REJECTED:
        return (
          <>
            <Flex gap={"middle"} align="start">
              <CloseCircleFilled style={{ marginTop: "6px", fontSize: "20px", color: "#F23030" }} />
              <Flex vertical>
                <Text strong className="text-base text-rejected">
                  Application Rejected
                </Text>
              </Flex>
            </Flex>
          </>
        );
    }
  };

  if (error) {
    return <ErrorPage error={error} />;
  }

  return (
    <>
      <List
        className="__applied__jobs"
        loading={isFetching}
        itemLayout="horizontal"
        dataSource={data}
        renderItem={(item) => (
          <List.Item>
            <Skeleton avatar title={false} loading={isFetching} active>
              <List.Item.Meta
                avatar={<Avatar src="https://api.dicebear.com/7.x/miniavs/svg?seed=1" />}
                title={<span style={{ fontSize: '1.25rem', fontWeight: 'bold' }}>
                  <Link to={`/enumerator/job/details/${item?.id}`} style={{ fontWeight: 600 }}>
                    {item?.jobTitle}
                  </Link>
                </span>}
                description={
                  <Flex vertical gap={2}>
                    <Text strong>{item?.companyName}</Text>
                    <Text type="secondary">{joblocationFormat(item)}</Text>
                  </Flex>
                }
              />
            </Skeleton>
            <div>{getJobStatus(item?.applicant?.status)}</div>
          </List.Item>
        )}
      />
    </>
  );
};

export default AppliedJobs;
